var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "xr-create",
    {
      attrs: { loading: _vm.loading, title: _vm.title },
      on: { close: _vm.close, save: _vm.saveClick },
    },
    [
      _c(
        "create-sections",
        { attrs: { title: "基本信息" } },
        [
          _c(
            "el-form",
            {
              ref: "crmForm",
              staticClass: "wk-form",
              attrs: {
                model: _vm.fieldForm,
                rules: _vm.fieldRules,
                "validate-on-rule-change": false,
                "label-position": "top",
              },
            },
            _vm._l(_vm.fieldList, function (children, index) {
              return _c("wk-form-items", {
                key: index,
                attrs: {
                  "field-from": _vm.fieldForm,
                  "field-list": children,
                  "ignore-fields": _vm.ignoreFields,
                },
                on: { change: _vm.formChange },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function ({ data }) {
                        return [
                          data && data.field == "status"
                            ? _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  on: {
                                    change: function ($event) {
                                      return _vm.formChange(data, index, $event)
                                    },
                                  },
                                  model: {
                                    value: _vm.fieldForm[data.field],
                                    callback: function ($$v) {
                                      _vm.$set(_vm.fieldForm, data.field, $$v)
                                    },
                                    expression: "fieldForm[data.field]",
                                  },
                                },
                                _vm._l(data.setting, function (item) {
                                  return _c("el-option", {
                                    key: item,
                                    attrs: { label: item, value: item },
                                  })
                                }),
                                1
                              )
                            : data && data.form_type == "category"
                            ? _c("xh-prouct-cate", {
                                attrs: {
                                  disabled: data.disabled,
                                  value: _vm.fieldForm[data.field],
                                },
                                on: {
                                  "value-change": function ($event) {
                                    return _vm.otherChange($event, data)
                                  },
                                },
                              })
                            : _vm._e(),
                        ]
                      },
                    },
                  ],
                  null,
                  true
                ),
              })
            }),
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "create-sections",
        { attrs: { title: "图片信息" } },
        [
          _c("detail-img", {
            attrs: { detail: _vm.imageData },
            on: { change: _vm.detailImgChange, delete: _vm.deleteImg },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }